var _rect, _path, _path2, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 24,
    rx: 5,
    fill: "#1B1C28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1471 18.201V17.7512H14.5163C14.5163 18.9817 14.3812 18.8757 12.8579 18.8757C12.3925 18.8757 12.1471 18.6427 12.1471 18.201ZM14.0425 20H12.6885C12.4043 19.9777 12.1392 19.9256 11.9089 19.8138C11.2031 19.4712 10.9615 18.8635 10.9625 18.1261C10.964 16.9589 11.0488 17.5353 10.7027 17.0609C10.6474 16.9851 10.5865 16.8834 10.5403 16.8027C10.0731 15.9868 10.7714 15.1666 9.4711 13.9197C9.37598 13.8284 9.35775 13.7869 9.27336 13.6951C8.38733 12.7314 8.00098 11.6592 8.00098 10.2178C8.00098 9.22688 8.41707 8.18113 8.96525 7.46003C10.4957 5.44686 13.3488 4.76981 15.6225 5.8321C15.9223 5.97216 16.1472 6.10126 16.42 6.27455C16.7711 6.4976 17.0041 6.71695 17.2708 7.0036C17.3273 7.0643 17.3707 7.09419 17.429 7.15336L17.95 7.85819C18.9606 9.5344 18.9065 11.6445 17.7708 13.2319C17.5751 13.5055 17.3619 13.7158 17.1503 13.9547C17.0727 14.0423 17.0197 14.0729 16.9411 14.1684C16.6436 14.5304 16.501 14.8476 16.3708 15.3512C16.2341 15.8802 16.3848 16.3647 16.109 16.8267C16.0595 16.9096 15.9839 17.0383 15.9271 17.1038C15.8732 17.1659 15.7477 17.2546 15.7204 17.3199C15.6046 17.597 15.8274 18.2898 15.5883 18.9187C15.3679 19.4982 14.6914 20 14.0425 20ZM14.3979 16.6269H12.2656C10.9943 16.6269 12.0609 15.274 10.8727 13.7137C10.5826 13.3327 10.6121 13.4164 10.3761 13.1356C10.1293 12.842 10.2582 13.0902 9.86466 12.5342C8.84541 11.0939 9.01981 9.15181 10.2239 7.79264C10.7133 7.24007 11.5701 6.75438 12.3212 6.59761C13.2995 6.39344 14.2038 6.45315 15.1225 6.86896C17.2187 7.81774 18.2029 10.393 16.8196 12.5165C16.6284 12.8101 16.4875 12.9077 16.3269 13.0982L15.8132 13.6976C15.0165 14.7071 15.1709 15.8389 15.0807 16.188C15.0058 16.4779 14.7655 16.6269 14.3979 16.6269Z",
    fill: "#2488FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4492 9.76813C10.4492 10.3893 11.1414 10.524 11.4867 10.1907C11.5966 10.0847 11.6316 9.94339 11.6874 9.7815C11.7827 9.50521 12.0206 9.22883 12.2419 9.07098C12.8985 8.60277 13.3548 8.83812 13.6726 8.62989C14.1485 8.31807 13.8987 7.5943 13.4108 7.5943C12.1948 7.5943 11.4068 8.0501 10.8041 8.90564C10.6887 9.06945 10.4492 9.5077 10.4492 9.76813Z",
    fill: "#2488FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 3.78845,
    width: 2.66667,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(50.9621 6.5 3.78845)",
    fill: "#2488FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7461,
    y: 1.48016,
    width: 2.66667,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(90 13.7461 1.48016)",
    fill: "#2488FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5781,
    y: 4.51208,
    width: 2.66667,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(120 20.5781 4.51208)",
    fill: "#2488FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicIcon);
export default __webpack_public_path__ + "static/media/LogicIcon.3fec5a75a9c211999d1b009e36e2f844.svg";
export { ForwardRef as ReactComponent };